module.exports = __webpack_public_path__ + "img/bingbao.01e5358a.png";